/** 墨迹正式站（moji.com / bjsdcx.com），不含 mojitest 测试域 */
export function isMojiProductionHost(hostname: string): boolean {
  const host = hostname.toLowerCase()
  if (host.includes('mojitest')) return false
  return (
    host === 'moji.com' ||
    host.endsWith('.moji.com') ||
    host === 'bjsdcx.com' ||
    host.endsWith('.bjsdcx.com')
  )
}

/** 本机 / 局域网调试 */
export function isLocalDevHost(hostname: string): boolean {
  const host = hostname.toLowerCase()
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') return true
  return /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)\d{1,3}\.\d{1,3}$/.test(host)
}

/** 测试环境（如 wwwmoji.mojitest.com） */
export function isMojitestHost(hostname: string): boolean {
  return hostname.toLowerCase().includes('mojitest')
}

/**
 * 首页「设备调试信息」面板是否展示（按访问域名，与 NUXT_ENV 无关）。
 *
 * | 场景 | 是否展示 |
 * |------|----------|
 * | localhost / 127.0.0.1 / 局域网 IP | ✓ |
 * | npm run dev 且非 moji 正式域 | ✓ |
 * | 含 mojitest 的域名（测试站） | ✗ |
 * | moji.com / *.moji.com / bjsdcx.com | ✗ |
 * | 其他域名上的生产构建 | ✗ |
 */
export function shouldShowDeviceDebugPanel(hostname?: string): boolean {
  if (typeof window === 'undefined') return false

  const host = (hostname ?? window.location.hostname).toLowerCase()

  if (isMojiProductionHost(host)) return false
  if (isMojitestHost(host)) return false
  if (isLocalDevHost(host)) return true

  return import.meta.dev
}
